/**
 * @desc 获取用户审批任务列表
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<
  defs.activiti.PageInfo<defs.activiti.BusinessTaskResponseDto>
>;
export function request(
  body: defs.activiti.BpmApprovalTaskRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/getApprovalTaskList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
